// MobileControls.js - 移动端控制器管理器
import VirtualJoystick from './VirtualJoystick.js';
import VirtualButtons from './VirtualButtons.js';

export default class MobileControls {
    constructor(scene) {
        this.scene = scene;
        this.joystick = null;
        this.buttons = null;
        this.isMobile = this.detectMobile();
        this.enabled = false;
    }
    
    /**
     * 检测是否为移动设备
     */
    detectMobile() {
        // 检测触摸支持
        const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        
        // 检测屏幕尺寸（移动设备通常宽度小于768px）
        const isSmallScreen = window.innerWidth < 768;
        
        // 检测用户代理
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const isMobileUA = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
        
        return hasTouch && (isSmallScreen || isMobileUA);
    }
    
    /**
     * 初始化移动端控制器
     */
    initialize() {
        if (!this.isMobile) {
            return;
        }
        
        // 如果已经初始化，先销毁旧的
        if (this.joystick || this.buttons) {
            this.destroy();
        }
        
        const { width, height } = this.scene.cameras.main;
        
        // 创建虚拟摇杆（左下角）
        const joystickX = 80;
        const joystickY = height - 80;
        this.joystick = new VirtualJoystick(this.scene, joystickX, joystickY, 60);
        
        // 创建虚拟按键
        this.buttons = new VirtualButtons(this.scene);
        
        // 设置按键回调
        this.setupButtonCallbacks();
        
        this.enabled = true;
    }
    
    /**
     * 设置按键回调
     */
    setupButtonCallbacks() {
        if (!this.buttons) return;
        
        // 确认按钮（对应空格键）
        this.buttons.setCallback('confirm', () => {
            if (this.scene.spaceKey) {
                // 模拟空格键按下
                this.scene.spaceKey.emit('down');
            }
        });
        
        // 菜单按钮（对应E键）
        this.buttons.setCallback('menu', () => {
            if (this.scene.eKey) {
                // 模拟E键按下
                this.scene.eKey.emit('down');
            }
        });
        
        // 上/下车按钮（对应V键）
        this.buttons.setCallback('vehicle', () => {
            // 直接调用上下车方法，而不是触发按键事件
            if (this.scene.worldPlayer && this.scene.player && this.scene.player.vehicle) {
                this.scene.worldPlayer.toggleVehicle(this.scene.player, this.scene.player.vehicle);
            }
        });
    }
    
    /**
     * 获取虚拟摇杆的 cursors 对象
     * 如果移动端控制器启用，返回虚拟摇杆的 cursors，否则返回 null
     */
    getCursors() {
        if (this.enabled && this.joystick) {
            return this.joystick.getCursors();
        }
        return null;
    }
    
    /**
     * 设置控制器可见性
     */
    setVisible(visible) {
        if (this.joystick) {
            this.joystick.setVisible(visible);
        }
        if (this.buttons) {
            this.buttons.setVisible(visible);
        }
    }
    
    /**
     * 销毁控制器
     */
    destroy() {
        if (this.joystick) {
            this.joystick.destroy();
            this.joystick = null;
        }
        if (this.buttons) {
            this.buttons.destroy();
            this.buttons = null;
        }
        this.enabled = false;
    }
}

